import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobileNotice from "./MobileNotice";
import DesktopNotice from "./DesktopNotice";

const NoticePage = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobileNotice />;

  return <DesktopNotice />;
});

export default NoticePage;
